module.exports = __webpack_public_path__ + "static/DHCM5-37ffa5eeac64fe1f430b91faf83812e1.png";